export const mapNullableStringToString = (
  str: string | null | undefined,
): string | undefined => {
  return str ?? undefined;
};
